'use client';
import { jsx } from 'react/jsx-runtime';
import { Fragment, useMemo } from 'react';
import { isNonNullish } from '../../../core/utilities/is.utils.js';
import { getSameKeyValueMapForManifest, manifestResolve } from '../../../core/utilities/manifest.utils.js';
import { useSwanHeadConfig } from './head.hook.js';
import { MANIFEST_STYLES } from '../../../core/manifest/styles.js';
import { SwanAssetFolders } from '../../../core/types/enums.js';

const SWAN_STYLE_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_STYLES);
let E = [
    SWAN_STYLE_KEY_MAP.core,
    SWAN_STYLE_KEY_MAP.utility,
    ...Object.keys(MANIFEST_STYLES).filter((t)=>t !== SWAN_STYLE_KEY_MAP.core && t !== SWAN_STYLE_KEY_MAP.utility)
];
const SWAN_STYLE_KEY_LIST = E;
function getSwanStylesheetUrl(t, e, r) {
    return manifestResolve(MANIFEST_STYLES, t, SwanAssetFolders.STYLES, e, r);
}
const SwanStylesheets = ({ styleSheetKeys: i = SWAN_STYLE_KEY_LIST, swanPathType: o, swanBaseUrl: _, swanTenant: l, swanLocale: E, renderWith: Y = Fragment })=>{
    let { swanBaseUrl: n, swanPathType: A } = useSwanHeadConfig(_, o, l, E);
    return jsx(Y, {
        children: useMemo(()=>{
            let t = new Set(i);
            t.delete(SWAN_STYLE_KEY_MAP.core), t.delete(SWAN_STYLE_KEY_MAP.utility);
            let e = Array.from(t);
            return e.sort(), e.unshift(SWAN_STYLE_KEY_MAP.core, SWAN_STYLE_KEY_MAP.utility), e.map((t)=>getSwanStylesheetUrl(t, A, n)).filter(isNonNullish);
        }, [
            i,
            A,
            n
        ]).map((e)=>jsx("link", {
                rel: "stylesheet",
                href: e
            }, e))
    });
};

export { SWAN_STYLE_KEY_LIST, SWAN_STYLE_KEY_MAP, SwanStylesheets, getSwanStylesheetUrl };
